
export function AnswersTimelineResource({
  id,
  title,
  onEditClick,
}: {
  id: string | null | undefined;
  title: string;
  onEditClick?: () => void;
}) {
  if (id?.includes("references:")) return <span className="dark-gray">{title}</span>;

  return (
    <span className={`treatmentResource `}>
      <span className="bold capitalize" style={{ paddingRight: "15px" }}>
        {title}{" "}
      </span>
      {/*      
        {!isNurse(USER.get()) && (
          <CornerIconButton
            type="edit"
            onClick={async () => {
              await onEditClick?.();
            }}
          ></CornerIconButton>
        )} */}
    </span>
  );
}
